var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.answer.content !== ''),expression:"answer.content !== ''"}],ref:"scrollViewRef",staticClass:"chat-text f14 markdown-body",domProps:{"innerHTML":_vm._s(_vm.answer.markdownContent === '' ? _vm.answer.content : _vm.answer.markdownContent)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }